import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcDiningFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.646 2.25c.448 0 .812.364.812.813v4.333c0 2.228-1.396 4.086-3.25 4.512v9.03a.813.813 0 0 1-1.625 0v-9.03c-1.854-.426-3.25-2.284-3.25-4.512V3.063a.813.813 0 0 1 1.625 0v4.062a.813.813 0 0 0 1.625 0V3.063a.813.813 0 0 1 1.625 0v4.062a.813.813 0 0 0 1.625 0V3.063c0-.449.364-.813.813-.813M16.604 2.25c2.244 0 4.063 2.183 4.063 4.875 0 2.359-1.396 4.325-3.25 4.777v9.036a.813.813 0 0 1-1.626 0v-9.036c-1.854-.452-3.25-2.418-3.25-4.777 0-2.692 1.82-4.875 4.063-4.875"
  }));
}
var IcDiningFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcDiningFill));

export { IcDiningFill as I };
